
import React, { useState, useEffect } from "react";
import { Col, Row, Offcanvas } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { CiSearch } from "react-icons/ci";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { Inward365 } from "./Party To Group View/Inward365";
import { InwardDetail } from "./Party To Group View/InwardDetail";
import { InwardQuality } from "./Party To Group View/InwardQuality";
import { Billing365 } from "./Party To Group View/Billing365";
import { BillingDetail } from "./Party To Group View/BillingDetail";
import { BillingQuality } from "./Party To Group View/BillingQuality";
import { Balance365 } from "./Party To Group View/Balance365";
import { BalanceDetail } from "./Party To Group View/BalanceDetail";
import { BalanceQuality } from "./Party To Group View/BalanceQuality";
import { FilterBox } from "../../../components/FilterBox/FilterBox";
import { CiBank } from "react-icons/ci";
import { AccountToPGroupList, BalDetail, BalParty365, BalQuality, DlvDetail, DlvParty365, DlvQuality, InwDatetail, InwParty365, InwQuality, MasterFilterMain, MulBalDetail, MulBalParty365, MulBalQuality, MulDlvDetail, MulDlvParty365, MulDlvQuality, MulInwDetail, MulInwParty365, MulInwQuality, resetBalDetail, resetBalParty365, resetBalQuality, resetDlvDetail, resetDlvParty365, resetDlvQuality, resetInwDetail, resetInwParty365, resetInwQuality, resetMulBalDetail, resetMulBalParty365, resetMulBalQuality, resetMulDlvDetail, resetMulDlvParty365, resetMulDlvQuality, resetMulInwDetail, resetMulInwParty365, resetMulInwQuality } from "../../../Redux/Slice/Grey/PartyProfile/PartyProfileSlice";
import {
  FiUsers,
  FiHash,
  FiHome,
  FiUser,
  FiPhone,
  FiMail,
  FiAlertTriangle
} from "react-icons/fi";

import {
  MdBusiness,
  MdCreditCard,
  MdAccountBalance,
  MdNumbers,
  MdLocalPhone
} from "react-icons/md";
import {
  IoLocationOutline,
  IoBusinessOutline,
} from "react-icons/io5";
import userImg from "../../../img/DynamicSoftware.png";
import { Loader } from "../../../components/Loader/Loader";
import { useTheme } from "../../../Themecontext/Themecontext";


export const AccountToGroup = ({ showFilter, handleClose }) => {

  const dispatch = useDispatch()
  const location = useLocation();
  const navigate = useNavigate();

  const [activePage, setActivePage] = useState("Inward365");
  const [hoverIndex, setHoverIndex] = useState(null);
  const [Muldata, setMuldata] = useState([]);

  const { Colourdata, mainFilterData } = useSelector((state) => state.ClientLogin);
  const { 
    AccountToPGroupListData, 
    InwParty365Data, 
    AccountListLoding 
  } = useSelector((state) => state.PartyProfileSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;



  const [filters, setFilters] = useState({
    production: "",
    account: "",
  });

  const [search, setSearch] = useState({
    production: "",
    account: "",
  });

  const prevAccountRef = React.useRef(filters.account);

  useEffect(() => {
    const isAccountChanged = prevAccountRef.current !== filters.account;
    prevAccountRef.current = filters.account;

    if (isAccountChanged || activePage === "Inward365") {
      dispatch(resetInwParty365());
      dispatch(resetMulInwParty365());
    }

    dispatch(resetInwQuality());
    dispatch(resetMulInwQuality());
    dispatch(resetInwDetail());
    dispatch(resetMulInwDetail());
    dispatch(resetDlvParty365());
    dispatch(resetMulDlvParty365());
    dispatch(resetDlvQuality());
    dispatch(resetMulDlvQuality());
    dispatch(resetDlvDetail());
    dispatch(resetMulDlvDetail());
    dispatch(resetBalParty365());
    dispatch(resetMulBalParty365());
    dispatch(resetBalQuality());
    dispatch(resetMulBalQuality());
    dispatch(resetBalDetail());
    dispatch(resetMulBalDetail());

    const fetchData = async () => {
      if (!AccountToPGroupListData?.Data || !filters.account) return;

      const ids = AccountToPGroupListData.Data.map((el) =>
        String(el.ProductionGroupMstID)
      );

      const singleQuoted = ids.join(",");

      let mainApi;
      let mulApi;

      switch (activePage) {
        case "Inward365":
          mainApi = InwParty365;
          mulApi = MulInwParty365;
          break;

        case "InwardQuality":
          mainApi = InwQuality;
          mulApi = MulInwQuality;
          break;

        case "InwardDetail":
          mainApi = InwDatetail;
          mulApi = MulInwDetail;
          break;

        case "Balance365":
          mainApi = BalParty365;
          mulApi = MulBalParty365;
          break;

        case "BalanceQuality":
          mainApi = BalQuality;
          mulApi = MulBalQuality;
          break;

        case "BalanceDetail":
          mainApi = BalDetail;
          mulApi = MulBalDetail;
          break;

        case "Billing365":
          mainApi = DlvParty365;
          mulApi = MulDlvParty365;
          break;

        case "BillingQuality":
          mainApi = DlvQuality;
          mulApi = MulDlvQuality;
          break;

        case "BillingDetail":
          mainApi = DlvDetail;
          mulApi = MulDlvDetail;
          break;

        default:
          return;
      }

      // ✅ Fetch Account Details (Always needed for the Header Card) if it's a new account and we aren't on Inward365
      if (isAccountChanged && activePage !== "Inward365") {
        dispatch(
          InwParty365({
            PARTYWISEIds: filters.account?.toString() || "",
            id: singleQuoted?.toString() || "",
            value: "pg",
          })
        );
      }

      // ✅ Merging API
      dispatch(
        mainApi({
          PARTYWISEIds: filters.account?.toString() || "",
          id: singleQuoted?.toString() || "",
          value: "pg",
        })
      );

      // ✅ Group API
      const responses = await Promise.all(
        AccountToPGroupListData.Data.map((element) =>
          dispatch(
            mulApi({
              PARTYWISEIds: filters.account?.toString() || "",
              id: element.ProductionGroupMstID?.toString() || "",
              value: "pg",
            })
          )
        )
      );

      // ✅ Remove duplicate
      const uniqueMap = new Map();

      responses.forEach((res) => {
        const groupId = res.payload.group;

        if (!uniqueMap.has(groupId)) {
          uniqueMap.set(groupId, res.payload);
        }
      });

      setMuldata(Array.from(uniqueMap.values()));
    };

    fetchData();
  }, [AccountToPGroupListData, filters.account, activePage]);

  // Voice Search Handle Effect
  useEffect(() => {
    if (location.state?.searchParty && mainFilterData?.account_list && mainFilterData.account_list.length > 0) {
      const searchName = location.state.searchParty.toLowerCase();
      
      const stringSimilarity = (str1, str2) => {
        const getBigrams = (str) => {
          let bigrams = new Set();
          for (let i = 0; i < str.length - 1; i++) {
            bigrams.add(str.substring(i, i + 2));
          }
          return bigrams;
        };
        const bg1 = getBigrams(str1);
        const bg2 = getBigrams(str2);
        const union = bg1.size + bg2.size;
        if (union === 0) return 1;
        let hits = 0;
        for (let bg of bg1) {
          if (bg2.has(bg)) hits++;
        }
        return (2.0 * hits) / union;
      };

      const cleanString = (str) => {
        return str.replace(/\b(private|limited|pvt|ltd|and|co|company|opening)\b/gi, '').replace(/\s+/g, ' ').trim();
      };
      
      const cleanedSearch = cleanString(searchName);
      
      let bestMatch = null;
      let highestScore = 0;
      
      mainFilterData.account_list.forEach(a => {
        const accLabel = a.AcName.toLowerCase();
        const cleanedLabel = cleanString(accLabel);
        
        let score = 0;
        
        if (accLabel === searchName) {
          score = 10;
        } else if (accLabel.includes(searchName)) {
          score = 5;
        } else {
          score = stringSimilarity(cleanedSearch, cleanedLabel);
          const searchWords = cleanedSearch.split(' ');
          const labelWords = cleanedLabel.split(' ');
          if (searchWords[0] && labelWords[0] && searchWords[0].length > 2) {
            if (labelWords[0].includes(searchWords[0]) || searchWords[0].includes(labelWords[0])) {
               score += 0.5;
            }
          }
        }
        
        if (score > highestScore) {
          highestScore = score;
          bestMatch = a;
        }
      });
      
      const matchedAccount = highestScore > 0.3 ? bestMatch : null;
      
      if (matchedAccount) {
        setFilters(prev => {
          if (prev.account !== matchedAccount.AcID) {
            dispatch(AccountToPGroupList(matchedAccount.AcID));
            return { ...prev, account: matchedAccount.AcID };
          }
          return prev;
        });
        
        navigate(location.pathname, { replace: true, state: {} });
      }
    }
  }, [location.state, mainFilterData, dispatch, navigate, location.pathname]);


  const productionGroups = [
    { label: "All", value: "all" },   // ✅ ADD THIS
    ...(AccountToPGroupListData?.Data?.map((item) => ({
      label: item.ProductionGroupMstName,
      value: item.ProductionGroupMstID,
    })) || [])
  ];

  const accountGroups =
    mainFilterData?.account_list?.map((item) => ({
      label: item.AcName,
      value: item.AcID,
    })) || [];

  const toggleItem = async (type, item) => {

    dispatch(resetInwParty365());
    dispatch(resetMulInwParty365());
    dispatch(resetInwQuality());
    dispatch(resetMulInwQuality());
    dispatch(resetInwDetail());
    dispatch(resetMulInwDetail());
    dispatch(resetDlvParty365());
    dispatch(resetMulDlvParty365());
    dispatch(resetDlvQuality());
    dispatch(resetMulDlvQuality());
    dispatch(resetDlvDetail());
    dispatch(resetMulDlvDetail());
    dispatch(resetBalParty365());
    dispatch(resetMulBalParty365());
    dispatch(resetBalQuality());
    dispatch(resetMulBalQuality());
    dispatch(resetBalDetail());
    dispatch(resetMulBalDetail());
    let newValue;

    setFilters((prev) => {
      newValue = prev[type] === item.value ? "" : item.value;

      if (type === "account") {
        dispatch(AccountToPGroupList(newValue));
      }

      return {
        ...prev,
        [type]: newValue
      };
    });

    // 🔥 production logic
    if (type === "production") {

      if (!filters.account) return;

      let mainApi;
      let mulApi;

      // 🔥 SAME LOGIC AS useEffect
      switch (activePage) {
        case "Inward365":
          mainApi = InwParty365;
          mulApi = MulInwParty365;
          break;

        case "InwardQuality":
          mainApi = InwQuality;
          mulApi = MulInwQuality;
          break;

        case "InwardDetail":
          mainApi = InwDatetail;
          mulApi = MulInwDetail;
          break;

        case "Balance365":
          mainApi = BalParty365;
          mulApi = MulBalParty365;
          break;

        case "BalanceQuality":
          mainApi = BalQuality;
          mulApi = MulBalQuality;
          break;

        case "BalanceDetail":
          mainApi = BalDetail;
          mulApi = MulBalDetail;
          break;

        case "Billing365":
          mainApi = DlvParty365;
          mulApi = MulDlvParty365;
          break;

        case "BillingQuality":
          mainApi = DlvQuality;
          mulApi = MulDlvQuality;
          break;

        case "BillingDetail":
          mainApi = DlvDetail;
          mulApi = MulDlvDetail;
          break;

        default:
          return;
      }

      if (item.value === "all") {

        const ids =
          AccountToPGroupListData?.Data?.map(el =>
            String(el.ProductionGroupMstID)
          ) || [];

        // 🔹 merging
        dispatch(
          mainApi({
            PARTYWISEIds: filters.account?.toString() || "",
            id: ids?.toString() || "",
            value: "pg"
          })
        );

        setMuldata([]);
      }
      else {
        dispatch(
          mainApi({
            PARTYWISEIds: filters.account?.toString() || "",
            id: item.value?.toString() || "",
            value: "pg"
          })
        );

        const res = await dispatch(
          mulApi({
            PARTYWISEIds: filters.account?.toString() || "",
            id: item.value?.toString() || "",
            value: "pg",
          })
        );

        setMuldata([res.payload]);
      }
    }
  };

  const selectAll = (type) => {
    setFilters((prev) => {
      const newValue = "";
      return {
        ...prev,
        [type]: newValue
      };
    });
  };

  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };


  const renderPage = () => {
    const commonProps = {
      selectedProduction: filters.production,
      selectedAccount: filters.account,
      Muldata: Muldata
    }


    switch (activePage) {
      case "Inward365":
        return <div><Inward365 {...commonProps} /></div>;

      case "InwardQuality":
        return <div> <InwardQuality {...commonProps} /></div>;

      case "InwardDetail":
        return <div><InwardDetail {...commonProps} /></div>;

      case "Billing365":
        return <div><Billing365 {...commonProps} /></div>;

      case "BillingQuality":
        return <div><BillingQuality {...commonProps} /></div>;

      case "BillingDetail":
        return <div><BillingDetail {...commonProps} /></div>;

      case "Balance365":
        return <div><Balance365 {...commonProps} /></div>;

      case "BalanceQuality":
        return <div><BalanceQuality {...commonProps} /></div>;

      case "BalanceDetail":
        return <div><BalanceDetail {...commonProps} /></div>;

      default:
        return null;
    }
  };



  if (AccountListLoding) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-green-700">
        <Loader />
      </div>
    );
  }



  const showAccountCardPages = [
    "Inward365",
    "InwardQuality",
    "InwardDetail",
    "Billing365",
    "BillingDetail",
    "BillingQuality",
    "Balance365",
    "BalanceQuality",
    "BalanceDetail"
  ];

  const showAccountCard = showAccountCardPages.includes(activePage);


  const boxData = [
    { label: "GROUP", value: InwParty365Data?.InwPartyDtl?.[0]?.GroupName || "-", icon: <FiUsers size={22} /> },
    { label: "GST NO", value: InwParty365Data?.InwPartyDtl?.[0]?.GSTNO || "-", icon: <FiHash size={22} /> },

    { label: "DEPARTMENT", value: InwParty365Data?.InwPartyDtl?.[0]?.Department || "-", icon: <MdBusiness size={22} /> },
    { label: "PAN NO", value: InwParty365Data?.InwPartyDtl?.[0]?.PanNo || "-", icon: <MdCreditCard size={22} /> },

    { label: "CONTACT PERSON 1", value: InwParty365Data?.InwPartyDtl?.[0]?.ContactPerson1 || "0", icon: <FiUser size={22} /> },
    { label: "MOBILE NO", value: InwParty365Data?.InwPartyDtl?.[0]?.MobilNO || "-", icon: <FiPhone size={22} /> },

    { label: "CONTACT PERSON 2", value: InwParty365Data?.InwPartyDtl?.[0]?.ContactPerson2 || "0", icon: <FiUser size={22} /> },
    { label: "MOBILE NO 1", value: InwParty365Data?.InwPartyDtl?.[0]?.MobilNO1 || "-", icon: <MdLocalPhone size={22} /> },

    { label: "EMAIL ID", value: InwParty365Data?.InwPartyDtl?.[0]?.EmailID || "-", icon: <FiMail size={22} /> },
    { label: "MSME NO", value: InwParty365Data?.InwPartyDtl?.[0]?.MSMENO || "-", icon: <MdNumbers size={22} /> },

    { label: "TELEPHONE NO", value: InwParty365Data?.InwPartyDtl?.[0]?.TelephoneNO || "-", icon: <FiPhone size={22} /> },
    { label: "EMERGENCY NO", value: InwParty365Data?.InwPartyDtl?.[0]?.EmergencyNO || "-", icon: <FiAlertTriangle size={22} /> },

    { label: "BANK DETAILS", value: InwParty365Data?.InwPartyDtl?.[0]?.BankName || "0", icon: <MdAccountBalance size={22} /> },
    { label: "IFSC CODE", value: InwParty365Data?.InwPartyDtl?.[0]?.IFSCCode || "-", icon: <FiHash size={22} /> },

    { label: "ACCOUNT NO", value: InwParty365Data?.InwPartyDtl?.[0]?.AccountNo || "-", icon: <MdCreditCard size={22} /> }
  ];

  const dummyData = {
    AcName: InwParty365Data?.InwPartyDtl?.[0]?.AcName || "",
    GSTNO: InwParty365Data?.InwPartyDtl?.[0]?.GSTNO || "-",
    Address1: InwParty365Data?.InwPartyDtl?.[0]?.Address1 || "-",
  };

  console.log(InwParty365Data?.InwPartyDtl?.[0]?.AcName);
  console.log(InwParty365Data?.InwPartyDtl?.[0]?.AcName || "");
  console.log(InwParty365Data);


  

    const renderAccountInfoCard = () => {

        return (
            <div>
                <div
                    style={{
                        borderRadius: "12px",
                        overflow: "hidden",
                        background:
                            isdark === "light"
                                ? iscolour?.Colour5
                                : iscolourDark?.Colour3,
                        border: `1px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                    }}
                >

                    <div
                        style={{
                            padding: "20px",
                            background:
                                isdark === "light"
                                    ? iscolour?.Colour1
                                    : iscolourDark?.Colour3,
                            borderBottom: `1px solid ${isdark === "light"
                                ? iscolour?.Colour5
                                : iscolourDark?.Colour6
                                }`,
                        }}
                    >
                        <Row className="align-items-center">
                            <Col xs={12}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "20px",
                                        flexWrap: "wrap",
                                    }}
                                >
                                    {/* IMAGE */}
                                    <img
                                        src={userImg}
                                        alt="Customer"
                                        style={{
                                            width: "95px",
                                            height: "95px",
                                            borderRadius: "20px",
                                            border: `2px solid ${isdark === "light"
                                                ? iscolour?.Colour5
                                                : iscolourDark?.Colour6
                                                }`,
                                        }}
                                    />

                                    {/* TEXT */}
                                    <div style={{ flex: 1 }}>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                gap: "10px",
                                            }}
                                        >
                                            {/* 🔥 LEFT SIDE (NAME + ADDRESS together NO GAP) */}
                                            <div style={{ flex: 1 }}>
                                                <div
                                                    style={{
                                                        color:
                                                            isdark === "light"
                                                                ? iscolour?.Colour11
                                                                : iscolourDark?.Colour2,
                                                        fontWeight: "700",
                                                        fontSize: "18px",
                                                        lineHeight: "20px",
                                                        marginBottom: "10px",
                                                    }}
                                                >
                                                    {dummyData.AcName}
                                                </div>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "6px",
                                                        marginTop: "2px",
                                                    }}
                                                >
                                                    <IoLocationOutline
                                                        style={{
                                                            fontSize: "14px",
                                                            color:
                                                                isdark === "light"
                                                                    ? iscolour?.Colour11
                                                                    : iscolourDark?.Colour4,
                                                        }}
                                                    />

                                                    <span
                                                        style={{
                                                            fontSize: "13px",
                                                            lineHeight: "16px",
                                                            color:
                                                                isdark === "light"
                                                                    ? iscolour?.Colour11
                                                                    : iscolourDark?.Colour4,
                                                        }}
                                                    >
                                                        {dummyData.Address1}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* 🔥 RIGHT SIDE GST (same row FIXED) */}
                                            <div
                                                style={{
                                                    flexShrink: 0,
                                                    minWidth: "220px",
                                                    padding: "10px 14px",
                                                    borderRadius: "12px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "10px",
                                                    whiteSpace: "nowrap",

                                                    background: "rgba(255, 255, 255, 0.22)",

                                                    backdropFilter: "blur(14px)",
                                                    WebkitBackdropFilter: "blur(14px)",
                                                    boxShadow:
                                                        "rgba(117, 82, 18, 0.12) 0px 10px 30px -10px, rgba(255, 255, 255, 0.6) 0px 1px 0px inset",
                                                }}
                                            >
                                                <IoBusinessOutline
                                                    style={{
                                                        fontSize: "18px",
                                                        color:
                                                            isdark === "light"
                                                                ? iscolour?.Colour5
                                                                : iscolourDark?.Colour2,
                                                    }}
                                                />

                                                <div
                                                    style={{
                                                        color:
                                                            isdark === "light"
                                                                ? iscolour?.Colour5
                                                                : iscolourDark?.Colour2,
                                                    }}
                                                >
                                                    <div style={{ fontSize: "11px", opacity: 0.8 }}>
                                                        TAX IDENTIFICATION
                                                    </div>

                                                    <div
                                                        style={{
                                                            fontWeight: "700",
                                                            letterSpacing: "1px",
                                                            fontSize: "15px",
                                                        }}
                                                    >
                                                        {dummyData.GSTNO}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    {/* 🔽 BOTTOM SECTION */}
                    <div style={{
                        padding: "12px",
                        background: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour3,
                    }}>
                        <Row className="g-2">
                            {boxData.map((item, i) => (
                                <Col xl={4} lg={4} md={6} sm={6} xs={12} key={i}>
                                    <div
                                        onMouseEnter={() => setHoverIndex(i)}
                                        onMouseLeave={() => setHoverIndex(null)}
                                        style={{
                                            borderRadius: "8px",
                                            padding: "10px",
                                            height: "70px",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                            background:
                                                isdark === "light"
                                                    ? iscolour?.Colour5
                                                    : iscolourDark?.Colour8,
                                            border: `1px solid ${isdark === "light"
                                                ? iscolour?.Colour4
                                                : iscolourDark?.Colour6}`,
                                            transition: "border-color 0.2s ease, background 0.2s ease",
                                        }}
                                    >
                                        {/* Icon */}
                                        <div
                                            style={{
                                                fontSize: "18px",
                                                minWidth: "38px",
                                                height: "38px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                color:
                                                    isdark === "light"
                                                        ? iscolour?.Colour5
                                                        : "#ffffff",
                                                background:
                                                    isdark === "light"
                                                        ? iscolour?.Colour6
                                                        : iscolourDark?.Colour1,
                                                borderRadius: "8px",
                                                flexShrink: 0,
                                            }}
                                        >
                                            {item.icon}
                                        </div>

                                        {/* Text */}
                                        <div style={{ flex: 1, overflow: "hidden" }}>
                                            <div
                                                style={{
                                                    fontSize: "11px",
                                                    fontWeight: "600",
                                                    letterSpacing: "0.5px",
                                                    textTransform: "uppercase",
                                                    color:
                                                        isdark === "light"
                                                            ? iscolour?.Colour6
                                                            : iscolourDark?.Colour4,
                                                    marginBottom: "2px",
                                                }}
                                            >
                                                {item.label}
                                            </div>
                                            <div
                                                style={{
                                                    fontSize: "13px",
                                                    fontWeight: "700",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    color:
                                                        isdark === "light"
                                                            ? iscolour?.Colour10
                                                            : iscolourDark?.Colour2,
                                                }}
                                            >
                                                {item.value}
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>
                </div>
            </div>
        );
    };

  const showAccountSummaryCard = [
  ];

  const showAccountSummary = showAccountSummaryCard.includes(activePage);

  const AccountSummaryCard = () => {

    const data = {
      accountGroup: "SUNDRY DEBTORS",
      productionGroup: "RAKESH",
      opening: 0,
      inward: 30108.25,
      delivery: 26615.00,
      balance: 0,
      shortage: 3493.25,
      elongation: 0
    };

    const boxStyle = {
      background: "#63b15f",
      borderRadius: "12px",
      padding: "15px",
      textAlign: "center",
      color: "#000",
      fontWeight: "600"
    };

    const headerBox = {
      background: "#2d5a2e",
      color: "#fff",
      padding: "10px 15px",
      borderRadius: "8px",
      fontWeight: "600"
    };

    return (
      <div className="p-3">

        {/* TOP ROW */}
        <Row className="mb-3 g-2">
          <Col md={6}>
            <div className="d-flex gap-2">
              <div style={headerBox}>ACCOUNT GROUP</div>
              <div style={{ ...boxStyle, flex: 1 }}>{data.accountGroup}</div>
            </div>
          </Col>

          <Col md={6}>
            <div className="d-flex gap-2">
              <div style={headerBox}>PROD. GROUP</div>
              <div style={{ ...boxStyle, flex: 1 }}>{data.productionGroup}</div>
            </div>
          </Col>
        </Row>

        {/* MAIN CARDS */}
        <Row className="g-3">

          <Col xl={3} md={6}>
            <div style={boxStyle}>
              <div>OPENING</div>
              <h5>{data.opening.toFixed(2)}</h5>
            </div>
          </Col>

          <Col xl={3} md={6}>
            <div style={boxStyle}>
              <div>INWARD</div>
              <h5>{data.inward.toLocaleString()}</h5>
            </div>
          </Col>

          <Col xl={3} md={6}>
            <div style={boxStyle}>
              <div>DELIVERY</div>
              <h5>{data.delivery.toLocaleString()}</h5>
            </div>
          </Col>

          <Col xl={3} md={6}>
            <div style={boxStyle}>
              <div>BALANCE</div>
              <h5>{data.balance.toFixed(2)}</h5>
            </div>
          </Col>

          <Col xl={3} md={6}>
            <div style={boxStyle}>
              <div>SHORTAGE</div>
              <h5>{data.shortage.toLocaleString()}</h5>
            </div>
          </Col>

          <Col xl={3} md={6}>
            <div style={boxStyle}>
              <div>ELONGATION</div>
              <h5>{data.elongation.toFixed(2)}</h5>
            </div>
          </Col>

        </Row>
      </div>
    );
  };


  const getBtnStyle = (page) => {
    const isActive = activePage === page;

    return {
      border: `2px solid ${isdark === "light"
        ? iscolour?.Colour1
        : iscolourDark?.Colour12
        }`,
      background: isActive
        ? (isdark === "light"
          ? iscolour?.Colour1   // active bg
          : iscolourDark?.Colour3)
        : (isdark === "light"
          ? iscolour?.Colour5  // inactive bg
          : iscolourDark?.Colour6),
      color: isActive
        ? (isdark === "light"
          ? iscolour?.Colour5
          : iscolourDark?.Colour2)
        : (isdark === "light"
          ? iscolour?.Colour2
          : iscolourDark?.Colour2),
      padding: "10px",
      borderRadius: "10px",
      fontWeight: "600",
      transition: "0.3s"
    };
  };



  if (mainFilterData === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-green-700">
        <Loader />
      </div>
    );
  }


  return (
    <div className="pageContainer">
      <Row >

        {/* LEFT FILTER */}
        <Col xl={3} lg={4} md={12} className="mb-3 d-none d-lg-block">
          <div style={{ flexDirection: "column", gap: "15px", display: "flex" }} >
            {/* ACCOUNT FILTER */}

            <FilterBox
              title="Account Name"
              items={accountGroups}
              search={search.account}
              setSearch={(val) => handleSearch("account", val)}
              selectedItems={
                filters.account ? [filters.account] : []
              }
              toggleItem={(item) => toggleItem("account", item)}
              selectAll={() => selectAll("account", accountGroups)}
              isMulti={false}
            />

            {filters.account && (
              < FilterBox
                title="Production Group"
                items={productionGroups}
                search={search.production}
                setSearch={(val) => handleSearch("production", val)}
                selectedItems={
                  filters.production ? [filters.production] : []
                }
                toggleItem={(item) => toggleItem("production", item)}
                selectAll={() => selectAll("production", productionGroups)}
                isMulti={false}
              />
            )}


          </div>
        </Col>

        <Offcanvas show={showFilter} onHide={handleClose} placement="start" className="d-lg-none">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Filters</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div style={{ flexDirection: "column", gap: "15px", display: "flex" }} >


              {/* ACCOUNT FILTER */}
              <FilterBox
                title="Account Group"
                items={accountGroups}
                search={search.account}
                setSearch={(val) => handleSearch("account", val)}
                selectedItems={
                  filters.account ? [filters.account] : []
                }
                toggleItem={(item) => toggleItem("account", item)}
                selectAll={() => selectAll("account", accountGroups)}
                isMulti={false}   // ✅ only here
              />

              {filters.account && (
                < FilterBox
                  title="Production Group"
                  items={productionGroups}
                  search={search.production}
                  setSearch={(val) => handleSearch("production", val)}
                  selectedItems={
                    filters.production ? [filters.production] : []
                  }
                  toggleItem={(item) => toggleItem("production", item)}
                  selectAll={() => selectAll("production", productionGroups)}
                  isMulti={false}
                />
              )}
            </div>
          </Offcanvas.Body>
        </Offcanvas>

        {/* RIGHT SIDE */}
        <Col xl={9} lg={8} md={12}>

          <Row >

            {/* INWARD */}
            <Col lg={4} md={6} sm={12}>
              <div
                className="p-3 h-100"
                style={{
                  border: `2px solid ${isdark === "light"
                    ? iscolour?.Colour8
                    : iscolourDark?.Colour12
                    }`,
                  background: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour7,
                  borderRadius: "18px",
                }}
              >

                <div
                  className="text-center mb-3"
                  style={{
                    background: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour12,
                    color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour2,
                    padding: "12px",
                    borderRadius: "12px",
                    fontWeight: "700"
                  }}
                >
                  INWARD
                </div>

                <button
                  onClick={() => setActivePage("Inward365")}
                  className="w-100 mb-2 hover-scale-btn"
                  style={getBtnStyle("Inward365")}
                >
                  INWARD 365
                </button>
                <button
                  onClick={() => setActivePage("InwardQuality")}
                  className="w-100 mb-2 hover-scale-btn"
                  style={getBtnStyle("InwardQuality")}
                >
                  INW. QUALITY
                </button>

                <button
                  onClick={() => setActivePage("InwardDetail")}
                  className="w-100 hover-scale-btn"
                  style={getBtnStyle("InwardDetail")}
                >
                  INWARD DETAIL
                </button>


              </div>
            </Col>

            {/* DELIVERY */}
            <Col lg={4} md={6} sm={12} >
              <div
                className="p-3 h-100"
                style={{
                  border: `2px solid ${isdark === "light"
                    ? iscolour?.Colour8
                    : iscolourDark?.Colour12
                    }`,
                  background: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour7,
                  borderRadius: "18px",
                }}
              >

                <div
                  className="text-center mb-3"
                  style={{
                    background: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour12,
                    color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour2,
                    padding: "12px",
                    borderRadius: "12px",
                    fontWeight: "700"
                  }}
                >
                  DELIVERY
                </div>

                <button
                  onClick={() => setActivePage("Billing365")}
                  className="w-100 mb-2 hover-scale-btn"
                  style={getBtnStyle("Billing365")}
                >
                  BILLING 365
                </button>

                <button
                  onClick={() => setActivePage("BillingQuality")}
                  className="w-100 mb-2 hover-scale-btn"
                  style={getBtnStyle("BillingQuality")}
                >
                  BILLING QTY
                </button>

                <button
                  onClick={() => setActivePage("BillingDetail")}
                  className="w-100 hover-scale-btn"
                  style={getBtnStyle("BillingDetail")}
                >
                  BILLING DETAIL
                </button>

              </div>
            </Col>

            {/* BALANCE */}
            <Col lg={4} md={6} sm={12} >
              <div
                className="p-3 h-100"
                style={{
                  border: `2px solid ${isdark === "light"
                    ? iscolour?.Colour8
                    : iscolourDark?.Colour12
                    }`,
                  background: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour7,
                  borderRadius: "18px",
                }}
              >

                <div
                  className="text-center mb-3"
                  style={{
                    background: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour12,
                    color: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour2,
                    padding: "12px",
                    borderRadius: "12px",
                    fontWeight: "700"
                  }}
                >
                  BALANCE
                </div>

                <button
                  onClick={() => setActivePage("Balance365")}
                  className="w-100 mb-2 hover-scale-btn"
                  style={getBtnStyle("Balance365")}
                >
                  BALANCE 365
                </button>

                <button
                  onClick={() => setActivePage("BalanceQuality")}
                  className="w-100 mb-2 hover-scale-btn"
                  style={getBtnStyle("BalanceQuality")}
                >
                  BALANCE QTY
                </button>

                <button
                  onClick={() => setActivePage("BalanceDetail")}
                  className="w-100 hover-scale-btn"
                  style={getBtnStyle("BalanceDetail")}
                >
                  BALANCE DETAIL
                </button>

              </div>
            </Col>

          </Row>

          {filters.account === "" ? (
            <h3
              className="text-center text-lg font-semibold pt-5"
              style={{
                color:
                  isdark === "light"
                    ? iscolour?.Colour2
                    : iscolourDark?.Colour2,
              }}
            >
              You must select an account to continue.
            </h3>
          ) : (
            <>
              <Row className="mt-4" >

                <div
                // style={{
                //     border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour12}`,
                //     background: isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour7,
                //     borderRadius: "20px"
                // }}
                >
                  {/* ACCOUNT INFO CARD */}
                  {showAccountCard && (

                    <Col className="mb-3">
                      {renderAccountInfoCard()}
                    </Col>

                  )}

                  {showAccountSummary && (

                    <Col className="mb-3">
                      {AccountSummaryCard()}
                    </Col>

                  )}


                  {/* PAGE RENDER */}
                  <Col>
                    {renderPage()}
                  </Col>
                </div>

              </Row>
            </>
          )}



        </Col>

      </Row >
    </div >
  )
}
